import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './index.css';
import Top from './Top';
import TourCreate from './TourCreate';
import TourEdit from "./TourEdit";
import TourDetails from './TourDetails';
import TourDetailsCreate from './TourDetailsCreate';
import Plans from './Plans';
import ImageEditPage from "./ImageEditPage";

const AppContent = () => {
  return (
    <Routes>
      <Route path="/" element={<Top />} />
      <Route path="/tour/create" element={<TourCreate />} />
      <Route path="/edit-tour/:id" element={<TourEdit />} />
      <Route path="/tour-details/:id" element={<TourDetails />} />
      <Route path="/create-tour-details/:tour_id" element={<TourDetailsCreate />} />
      <Route path="/plans/:tour_detail_id" element={<Plans />} />
      <Route path="/edit-images/:id" element={<ImageEditPage />} />
    </Routes>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
